/**
 * useCustomerTenantView.js — 운영자가 고른 고객 테넌트 보기 (2026-09-15)
 *   2026-10-02 CompanyScopeContext.jsx(292줄)에서 분리 — 글자 그대로 이동, 동작 변화 없음.
 *
 *   ① 그 테넌트 관리자와 같은 메뉴를 그리려고 서버에서 권한을 받는다(menu-perms). 못 받으면 빈 권한(fail-closed).
 *   ② customerView = { ready, isPrimary, permCodes, companyCode, companyMenu } — 고객 테넌트가 아니면 null.
 */
import { useEffect, useMemo, useState } from 'react';
import { apiClient } from '../../../api/apiClient';

export function useCustomerTenantView({ isCustomerTenant, selectedTenant, company }) {
  const [tenantMenu, setTenantMenu] = useState({ tenantCode: '', permCodes: null, companies: [], companyMenu: null });
  useEffect(() => {
    if (!isCustomerTenant) return undefined;
    const code = selectedTenant.code;
    let active = true;
    // 못 받으면 빈 권한 — 메뉴를 숨긴다(fail-closed)
    const failClosed = () => { if (active) setTenantMenu({ tenantCode: code, permCodes: new Set(), companies: [], companyMenu: null }); };
    apiClient.get(`/api/admin/saas/tenants/${code}/menu-perms`).then((r) => {
      if (!active) return;
      if (r.ok && Array.isArray(r.data?.perm_codes)) {
        setTenantMenu({
          tenantCode: code,
          permCodes: new Set(r.data.perm_codes),
          companies: r.data.companies || [],
          // 대표 회사의 회사별 메뉴표(급여·계약취소·매출 …) — 그 테넌트 관리자가 받는 것과 같은 계산
          companyMenu: r.data.company_menu || null,
        });
      } else failClosed();
    }).catch(failClosed);
    return () => { active = false; };
  }, [isCustomerTenant, selectedTenant]);

  return useMemo(() => {
    if (!isCustomerTenant || !company) return null;
    const ready = tenantMenu.tenantCode === selectedTenant.code && tenantMenu.permCodes instanceof Set;
    const upper = String(company.code).toUpperCase();
    const isPrimary = ready && tenantMenu.companies.some((c) => String(c.code).toUpperCase() === upper && c.is_primary);
    return {
      ready, isPrimary, permCodes: ready ? tenantMenu.permCodes : null, companyCode: company.code,
      companyMenu: ready ? tenantMenu.companyMenu : null,
    };
  }, [isCustomerTenant, company, tenantMenu, selectedTenant]);
}
